import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import { PAGES } from "..";
import { theme } from "../../theme";
import { COLORS } from "../../theme/colors";
import supplierImg from "../../assets/images/home/supplier.png";
import dashboardImg from "../../assets/images/home/dashboard.png";
import workspaceImg from "../../assets/images/home/workspace.png";

const useStyles = makeStyles(() => ({
  root: {
    padding: `${theme.spacing(10)}px ${theme.spacing(8)}px`,
  },
  title: {
    marginBottom: theme.spacing(12),
    fontWeight: 400,
  },
  subTitle: {
    position: "absolute",
    top: 265,
    color: COLORS.davisGrey,
  },
  enableSubTitle: {
    position: "absolute",
    top: 265,
  },
  img: {
    position: "absolute",
    bottom: 150,
    opacity: 0.2,
  },
  enableImg: {
    position: "absolute",
    bottom: 150,
  },
  card: {
    border: `1px solid ${COLORS.darks[0][10]}`,
    borderRadius: theme.spacing(1),
    width: 240,
    height: 370,
    position: "relative",
  },
  disableCard: {
    "& h6": {
      color: COLORS.gray[0],
    },
  },
  enableCard: {
    cursor: "pointer",
    "&:hover": {
      boxShadow: `0px 10px 10px ${COLORS.purples[10]}`,
      "& h6": {
        color: COLORS.purple,
      },
    },
  },
  rotatedCard: {
    boxShadow: "0px 12px 26px rgba(193, 37, 173, 0.06)",
    width: "100%",
    height: "100%",
    position: "absolute",
    backfaceVisibility: "hidden",
  },
  flipCard: {
    height: 370,
    width: 240,
  },
  flipCardInner: {
    width: "100%",
    height: "100%",
    textAlign: "center",
    position: "relative",
    transition: "transform 0.8s",
    transformStyle: "preserve-3d",
  },
  point: {
    width: 12,
    marginRight: theme.spacing(1),
  },
  workspaceItems: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
  },
  item: {
    marginBottom: theme.spacing(1),
  },
}));

const items = [
  {
    icon: dashboardImg,
    text: "PRaaS Dashboard",
  },
  {
    icon: workspaceImg,
    text: "PRaaS Workspace",
    enable: true,
  },
  {
    icon: supplierImg,
    text: "Digital Power",
  },
];

const workspaceItems = [
  { text: "Portfolio Data" },
  { text: "PRaaS Billing" },
  { text: "PRaaS Reports" },
  { text: "PRaaS Integration" },
  { text: "Portfolio Registration", path: PAGES.demo.portfolioRegistration },
  { text: "Portfolio Onboarding" },
];

const CardComponent = ({ className, item, onMouseEnter, onMouseLeave }) => {
  const classes = useStyles();

  return (
    <Grid
      className={`${className} ${classes.card} ${
        item.enable ? classes.enableCard : classes.disableCard
      }`}
      container
      direction="column"
      alignItems="center"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <img className={item.enable ? classes.enableImg : classes.img} src={item.icon} alt="icon" />
      <div className={item.enable ? classes.enableSubTitle : classes.subTitle}>
        <Typography variant="subtitle1" align="center">
          {item.text}
        </Typography>
      </div>
    </Grid>
  );
};

export const WelcomePage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [showBack, setShowBack] = useState(false);

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h1" align="center">
        We&apos;re happy you&apos;re here!
      </Typography>

      <Grid container justifyContent="center" spacing={4}>
        {items.map((item, index) => (
          <Grid item key={index}>
            {item.enable ? (
              <div className={classes.flipCard}>
                <div
                  className={classes.flipCardInner}
                  style={showBack ? { transform: "rotateY(180deg)" } : null}
                >
                  {/* Front card */}
                  <CardComponent
                    className={classes.rotatedCard}
                    item={item}
                    onMouseEnter={() => setShowBack(true)}
                  />

                  {/* Back card */}
                  <Grid
                    className={`${classes.rotatedCard} ${classes.card}`}
                    onMouseLeave={() => setShowBack(false)}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    style={{ transform: "rotateY(180deg)" }}
                  >
                    <div className={classes.workspaceItems}>
                      {workspaceItems.map((item, i) => (
                        <Grid className={classes.item} container key={i} alignItems="center">
                          <FiberManualRecordIcon className={classes.point} />
                          <Typography
                            onClick={() => item.path && navigate(item.path)}
                            style={
                              item.path
                                ? { color: COLORS.purple, cursor: "pointer" }
                                : { color: COLORS.darks[1] }
                            }
                          >
                            {item.text}
                          </Typography>
                        </Grid>
                      ))}
                    </div>
                  </Grid>
                </div>
              </div>
            ) : (
              <CardComponent item={item} />
            )}
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
